var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"userset-cont"},[_c('div',{staticClass:"contacts-tree"},[_c('el-tree',{attrs:{"data":_vm.contactData,"props":_vm.defaultProps,"node-key":"depId","expand-on-click-node":false,"default-expanded-keys":[1]},on:{"node-click":_vm.handleNodeClick}})],1),_vm._v(" "),_c('contacts')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ed9c8d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/set/userSet.vue
// module id = null
// module chunks = 